import { Observable } from 'rxjs';

import { SnCamera, SnLiveVideoUrls, SnStreamSources } from '@lib/api/entities';
import { SnVideoPlayerReference } from '@lib/player/video-player';

import { SnPlayerState } from '../enums';

export interface ISnPlayer {
  src: string | SnStreamSources | SnCamera | SnLiveVideoUrls;

  ptzOn?: boolean;
  muted?: boolean;
  live?: boolean;
  autoplay?: boolean;
  fullscreen?: boolean;
  currentTime?: number;
  reference?: SnVideoPlayerReference;
  actualTime?: number;
  camId?: string;
  parent?: any;
  showEvents?: boolean;
  local?: boolean;

  loopDuration?: number;

  ptzOn$?: Observable<boolean>;
  live$?: Observable<boolean>;
  state$?: Observable<SnPlayerState>;
  play$?: Observable<SnPlayerState>;
  pause$?: Observable<SnPlayerState>;
  end$?: Observable<SnPlayerState>;
  ended$?: Observable<void>;

  volume$?: Observable<number>;

  currentTime$?: Observable<number>;
  bufferTime$?: Observable<number>;
  totalTime$?: Observable<number>;
  connected$?: Observable<boolean>;
  loaded$?: Observable<boolean>;
  timeStamp?: Date;

  play: () => void;
  pause: () => void;
  changeCurrentTime?: (time: number) => void;
  changeVolume?: (volume: number) => void;
  changeFullscreen?: (ptzControls?: boolean) => void;
  exitedFullscreen?: (ptzControls?: boolean) => void;
  initialization?: () => void;
  forward?: (amount: number) => void;
  back?: (amount: number) => void;
  fastForward?: () => void;
  rewind?: () => void;
  destroyStream?: (bypassGroup?: boolean) => void;
}
